import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useGroups} from '@adv-mt/mt-list-model-details/lib/useGroups.js'
import {Accordion, AccordionHeader, AccordionItem, AccordionPanel} from '@adv-mt/ui/accordion'
import {Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import {ACCORDION_HEADER_ICONS} from '../accordionHeaderIcons.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-technicalDetailsDrawer`

const TechnicalDetailsDrawer = ({onClose, groupedSpecifications, standardEquipment = [], optionalEquipment = []}) => {
  const {i18n} = useSuiContext()
  const specGroups = useGroups(groupedSpecifications ?? {}).filter(Boolean)

  const normalizedSpecGroups = specGroups.map(({key, value: specItems}) => ({
    title: i18n.t(key),
    descriptions: specItems.filter(Boolean).map(({key: itemKey, keyParams, value: itemValue, params}) => ({
      value: `${i18n.t(itemKey, keyParams)}: ${typeof itemValue === 'string' ? i18n.t(itemValue, params) : itemValue}`
    }))
  }))

  const renderSection = (groups, title) =>
    groups.length > 0 && (
      <div className={`${BASE_CLASS}-section`}>
        <Subhead1 as="h3" className={`${BASE_CLASS}-sectionTitle`}>
          {title}
        </Subhead1>
        <Accordion openMultiple>
          {groups.map((group, index) => (
            <AccordionItem key={index} value={String(index)}>
              <AccordionHeader {...ACCORDION_HEADER_ICONS}>{group.title}</AccordionHeader>
              <AccordionPanel className={`${BASE_CLASS}-panel`}>
                {(group.descriptions || []).map((description, itemIndex) => (
                  <span className={`${BASE_CLASS}-item`} key={itemIndex}>
                    {typeof description === 'string' ? description : description.value}
                  </span>
                ))}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    )

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('COMMON.DETAIL_TECHNICAL_DATASHEET')}>
      <div className={BASE_CLASS}>
        {renderSection(normalizedSpecGroups, i18n.t('COMMON.EQUIPMENT.MAIN_SPECIFICATIONS'))}
        {renderSection(standardEquipment, i18n.t('COMMON.EQUIPMENT.STANDARD'))}
        {renderSection(optionalEquipment, i18n.t('COMMON.EQUIPMENT.OPTIONAL'))}
      </div>
    </BaseDrawer>
  )
}

TechnicalDetailsDrawer.displayName = 'TechnicalDetailsDrawer'
TechnicalDetailsDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  groupedSpecifications: PropTypes.object,
  optionalEquipment: PropTypes.arrayOf(PropTypes.shape({descriptions: PropTypes.array, title: PropTypes.string})),
  standardEquipment: PropTypes.arrayOf(PropTypes.shape({descriptions: PropTypes.array, title: PropTypes.string}))
}

export default TechnicalDetailsDrawer
